export default __webpack_public_path__ + "static/media/banner_error_404.3eb42a14.jpg";